import React from 'react'
import { FC } from 'react'

import SvgIcon from '../SVGIcon/SvgIcon'
import { cls } from '../../utils/utils'

import { IParallelepipedProps } from './Parallelepiped.types'
import styles from './Parallelepiped.module.scss'

export const Parallelepiped: FC<IParallelepipedProps> = ({ color, classname }) => (
  <SvgIcon href="/images/parallelepiped.svg#bg" className={cls(styles.parallelepiped, styles[color], classname)} />
)
